export default __webpack_public_path__ + "static/media/NTORQ 125_5.bdf65e01.webp";